// File touched to trigger re-indexing
import {
  FolderOpenOutlined,
  TeamOutlined,
  SettingOutlined,
  NotificationOutlined,
  IdcardOutlined,
  FileTextOutlined,
  BankOutlined,
  FileDoneOutlined,
  ShoppingOutlined,
  ShoppingCartOutlined,
  HomeOutlined,
  BarChartOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
  MobileOutlined,
  AppstoreOutlined,
  SwapOutlined,
  HistoryOutlined,
  AuditOutlined,
  ToolOutlined,
  CheckCircleOutlined,
  UnorderedListOutlined,
  CarOutlined,
} from "@ant-design/icons";

export interface SubModule {
  key: string;
  name: string;
  description: string;
}

export interface SystemModule {
  key: string;
  name: string;
  icon: any;
  submodules: SubModule[];
  disableRead?: boolean;
}

export const SYSTEM_MODULES: SystemModule[] = [
  {
    key: "proyectos",
    name: "PROYECTOS",
    icon: FolderOpenOutlined,
    submodules: [
      {
        key: "menuProyectos",
        name: "Acceso al módulo de proyectos",
        description: "Boton lateral en el menú de módulos",
      },
      {
        key: "archivo",
        name: "Archivar Proyectos",
        description:
          "Ver proyectos archivados y acciones de archivar/desarchivar",
      },
      {
        key: "gestion",
        name: "Gestión de Proyectos",
        description: "Ver, crear y editar proyectos en la lista de proyectos",
      },
      {
        key: "documentacion",
        name: "Documentación",
        description:
          "Acceso, ver, subir y editar archivos a las pestañas de Índice, Legal, Archivos y Entrega",
      },
      {
        key: "bitacoras",
        name: "Bitacoras de Proyectos",
        description: "Ver y crear bitacoras dentro de proyectos",
      },
      {
        key: "partidas",
        name: "Partidas",
        description: "Ver, crear, editar y eliminar partidas de proyecto",
      },
      {
        key: "gastos",
        name: "Gastos de proyecto",
        description: "Ver, crear y eliminar gastos de proyecto",
      },
      {
        key: "pagos",
        name: "Pagos de proyecto",
        description: "Ver, crear, editar y cancelar pagos de proyecto",
      },
      {
        key: "generacion",
        name: "Generador de documentos de proyecto",
        description: "Ver y generar documentos de proyecto",
      },
      {
        key: "finanzas",
        name: "Finanzas",
        description: "Resumen contable y rentabilidad",
      },
    ],
  },
  {
    key: "notificaciones",
    name: "NOTIFICACIONES",
    icon: NotificationOutlined,
    submodules: [
      {
        key: "centro",
        name: "Centro de Notificaciones",
        description: "Ver y gestionar notificaciones",
      },
      {
        key: "novedades",
        name: "Módulo de Novedades",
        description: "Ver el historial de cambios y versiones del sistema",
      },
    ],
  },
  {
    key: "rrhh",
    name: "RECURSOS HUMANOS",
    icon: IdcardOutlined,
    submodules: [
      {
        key: "empleados",
        name: "Empleados",
        description:
          "Ver, crear, editar, dar de baja, eliminar empleados y asignar obras",
      },
      {
        key: "gastos",
        name: "Gastos de empleados",
        description: "Ver, crear, editar y aprobar gastos de empleados",
      },
      {
        key: "nominas",
        name: "Gestión de Nóminas",
        description: "Ver, crear, editar y aprobar nóminas de empleados",
      },
      {
        key: "prestamos",
        name: "Gestión de préstamos",
        description: "Control de préstamos",
      },
      {
        key: "descuentos",
        name: "Descuentos de empleados",
        description:
          "Cargos quincenales a empleados (ej. pérdida de herramientas en préstamo)",
      },
      {
        key: "wallet",
        name: "Gestión de wallet",
        description: "Control de wallet de empleados",
      },
      {
        key: "bonos",
        name: "Bonos",
        description: "Asignación de bonos a encargados de proyecto",
      },
      {
        key: "sueldos",
        name: "Historial Salarial",
        description: "Ver y registrar aumentos de sueldo",
      },
    ],
  },
  {
    key: "configuracion",
    name: "CONFIGURACIÓN",
    icon: SettingOutlined,
    submodules: [
      {
        key: "usuarios",
        name: "Usuarios",
        description: "Administración de cuentas",
      },
      {
        key: "roles",
        name: "Roles",
        description: "Definición de perfiles de usuario",
      },
    ],
  },
  {
    key: "administracion",
    name: "ADMINISTRACIÓN",
    icon: BankOutlined,
    submodules: [
      {
        key: "comunicacion-interna",
        // Llave interna sin cambio (no romper roles ya configurados).
        name: "Normatividad",
        description: "Ver y gestionar circulares y comunicados de la empresa",
      },
      {
        key: "politicas",
        name: "Políticas de la empresa",
        description: "Ver y gestionar el documento de políticas",
      },
      {
        key: "documentacion",
        name: "Documentación interna",
        description:
          "Grupos de documentos: sociedad, opiniones, SAT, Repse, estados financieros e IMSS",
      },
      {
        key: "alianzas",
        name: "Alianzas Estratégicas",
        description:
          "Padrones de proveedores con gobierno y relaciones comerciales e institucionales",
      },
    ],
  },
  {
    key: "plantillas",
    name: "PLANTILLAS",
    icon: FileTextOutlined,
    submodules: [
      {
        key: "gestion",
        name: "Gestión de Plantillas",
        description: "Formatos base para documentos",
      },
    ],
  },
  {
    key: "empresas",
    name: "EMPRESAS",
    icon: BankOutlined,
    submodules: [
      {
        key: "gestion",
        name: "Gestión de Empresas",
        description: "Directorio de clientes y proveedores",
      },
    ],
  },
  {
    key: "facturas",
    name: "FACTURAS",
    icon: FileDoneOutlined,
    submodules: [
      {
        key: "control",
        name: "Control de Facturas",
        description: "Seguimiento de CFDI y cobros",
      },
      {
        key: "customer_quotations",
        name: "Cotizaciones a Clientes",
        description: "Presupuestos comerciales formales",
      },
    ],
  },
  {
    key: "cartaPorte",
    name: "CARTA PORTE",
    icon: FileDoneOutlined,
    submodules: [
      {
        key: "control",
        name: "Carta Porte",
        description: "Generación y timbrado de Carta Porte",
      },
    ],
  },
  {
    key: "productos",
    name: "PRODUCTOS",
    icon: ShoppingOutlined,
    submodules: [
      {
        key: "catalogo",
        name: "Catálogo de Productos",
        description: "Listado y precios base",
      },
    ],
  },
  {
    key: "compras",
    name: "COMPRAS",
    icon: ShoppingCartOutlined,
    submodules: [
      {
        key: "gestion",
        name: "Gestión de compra de productos",
        description: "Proceso de adquisición",
      },
    ],
  },
  {
    key: "almacen",
    name: "ALMACÉN",
    icon: HomeOutlined,
    submodules: [
      {
        key: "pendientes",
        name: "Productos pendientes por llegar",
        description: "Control de recepción",
      },
      {
        key: "gestion",
        name: "Almacenes",
        description: "Control de stock físico",
      },
      {
        key: "movimientos",
        name: "Movimientos de Inventario",
        description: "Entradas y salidas",
      },
      {
        key: "traspasos",
        name: "Traspasos",
        description: "Transferencia entre bodegas",
      },
      {
        key: "ajustes",
        name: "Ajustes de inventario",
        description: "Corrección de existencias",
      },
    ],
  },
  {
    key: "garantias",
    name: "GARANTÍAS",
    icon: SafetyCertificateOutlined,
    submodules: [
      {
        key: "menuGarantias",
        name: "Acceso al módulo de garantías",
        description: "Boton lateral en el menú de módulos",
      },
      {
        key: "gestion",
        name: "Gestión de Garantías",
        description: "Ver, crear y editar garantías",
      },
      {
        key: "operaciones",
        name: "Operaciones Especiales",
        description: "Recibir reemplazos, reembolsos y cierre de garantías",
      },
    ],
  },
  {
    key: "tickets_garantia",
    name: "TICKETS DE GARANTÍA",
    icon: SafetyCertificateOutlined,
    submodules: [
      {
        key: "gestion",
        name: "Ver y Gestionar Soporte",
        description: "Ver, responder y gestionar tickets de soporte",
      },
      {
        key: "mis_tickets",
        name: "Gestionar Mis Tickets",
        description:
          "Gestionar tickets de los proyectos asignados como responsable de configuración",
      },
      {
        key: "codigos",
        name: "Generar Código de Cliente",
        description:
          "Generar códigos de cliente y visualizar tickets en modo lectura",
      },
    ],
  },
  {
    key: "reportes",
    name: "REPORTES",
    icon: BarChartOutlined,
    submodules: [
      {
        key: "dashboard",
        name: "Dashboard General",
        description: "Estadísticas clave del sistema",
      },
    ],
  },
  {
    key: "pwa_traspasos",
    name: "ALMACÉN - TRASPASOS ENTRE PROYECTOS",
    icon: SwapOutlined,
    disableRead: true,
    submodules: [
      {
        key: "gestion",
        name: "Gestión de Traspasos",
        description:
          "Crear y gestionar traspasos entre almacenes desde la app móvil",
      },
    ],
  },
  {
    key: "pwa_solicitudes_configuracion",
    name: "ALMACÉN - SOLICITUDES DE CONFIGURACIÓN",
    icon: SettingOutlined,
    disableRead: true,
    submodules: [
      {
        key: "peticiones_configuracion",
        name: "Crear Peticiones de Configuración",
        description: "Solicitar configuración de productos",
      },
    ],
  },
  {
    key: "pwa_productos_por_llegar",
    name: "ALMACÉN - PRODUCTOS POR LLEGAR",
    icon: MobileOutlined,
    disableRead: true,
    submodules: [
      {
        key: "pendientes",
        name: "Productos Pendientes",
        description:
          "Consulta de productos pendientes por llegar desde la app móvil",
      },
    ],
  },
  {
    key: "pwa_almacen",
    name: "ALMACÉN - GESTIÓN DE PRODUCTOS",
    icon: HomeOutlined,
    disableRead: false,
    submodules: [
      {
        key: "productos",
        name: "Gestión de Productos",
        description:
          "Consulta y salida de productos del almacén desde la app móvil",
      },
    ],
  },
  {
    key: "pwa_seminuevos",
    name: "ALMACÉN - SEMINUEVOS",
    icon: HomeOutlined,
    disableRead: false,
    submodules: [
      {
        key: "ver",
        name: "Ver módulo",
        description: "Consultar el inventario de seminuevos (solo lectura)",
      },
      {
        key: "gestionar",
        name: "Gestionar seminuevos",
        description: "Solicitar, aprobar, devolver y mover seminuevos",
      },
    ],
  },
  {
    key: "pwa_movimientos",
    name: "ALMACÉN - MOVIMIENTOS",
    icon: HistoryOutlined,
    disableRead: true,
    submodules: [
      {
        key: "historial",
        name: "Historial de Movimientos",
        description: "Consulta de movimientos de inventario desde la app móvil",
      },
    ],
  },
  {
    key: "pwa_productos_en_configuracion",
    name: "ALMACÉN - PRODUCTOS EN CONFIGURACIÓN",
    icon: SettingOutlined,
    disableRead: true,
    submodules: [
      {
        key: "productos",
        name: "Lista de Productos en Configuración",
        description: "Productos en configuración",
      },
    ],
  },
  {
    key: "pwa_encargados_proyectos",
    name: "ALMACÉN - PROYECTOS (ENCARGADOS)",
    icon: FolderOpenOutlined,
    disableRead: true,
    submodules: [
      {
        key: "encargados_proyectos",
        name: "Detalle de Partidas por Proyecto",
        description: "Ver partidas y detalles dentro de un proyecto",
      },
    ],
  },
  {
    key: "pwa_ajustes",
    name: "ALMACÉN - AJUSTES DE INVENTARIO",
    icon: ToolOutlined,
    disableRead: true,
    submodules: [
      {
        key: "gestion",
        name: "Ajustes de Stock",
        description: "Solicitar, aprobar y gestionar modificaciones de stock",
      },
    ],
  },
  {
    key: "herramientas",
    name: "HERRAMIENTAS",
    icon: ToolOutlined,
    submodules: [
      {
        key: "gestion",
        name: "Gestión PWA (llave maestra)",
        description:
          "Acceso completo al módulo de Herramientas en la app móvil: catálogo, kits, entradas de stock, ubicaciones, movimientos y gestión de préstamos. Read: ver; Manage: crear/editar y operar",
      },
      {
        key: "catalogo",
        name: "Catálogo",
        description:
          "Ver y gestionar el catálogo de herramientas y tipos (crear, editar, eliminar)",
      },
      {
        key: "stock",
        name: "Stock por Almacén",
        description:
          "Consultar el stock de herramientas por almacén, disponibilidad y seriales",
      },
      {
        key: "movimientos",
        name: "Movimientos",
        description:
          "Consultar el historial de movimientos de herramientas (entradas, préstamos, devoluciones, pérdidas)",
      },
      {
        key: "ajustes",
        name: "Ajustes de Inventario",
        description:
          "Ver las peticiones de ajuste de inventario de herramientas (la aprobación requiere permiso de ajustes de almacén)",
      },
      {
        key: "prestamos",
        name: "Préstamos y Devoluciones",
        description:
          "Lectura: ver todas las solicitudes de préstamo de la PWA. Gestión: aprobar/rechazar solicitudes y registrar devoluciones (aplica en la PWA)",
      },
    ],
  },
  {
    key: "pwa_notificaciones",
    name: "ALMACÉN - NOTIFICACIONES",
    icon: NotificationOutlined,
    disableRead: true,
    submodules: [
      {
        key: "centro",
        name: "Centro de Notificaciones",
        description: "Ver y gestionar notificaciones desde la app móvil",
      },
    ],
  },
  {
    key: "pwa_encargados_movimientos",
    name: "ALMACÉN - MOVIMIENTOS (ENCARGADOS)",
    icon: FolderOpenOutlined,
    disableRead: true,
    submodules: [
      {
        key: "historial_responsable",
        name: "Movimientos por Responsable",
        description: "Consulta de movimientos agrupados por responsable",
      },
    ],
  },
  {
    key: "pwa_encargados_configuracion",
    name: "ALMACÉN - ENCARGADOS DE CONFIGURACIÓN",
    icon: SettingOutlined,
    disableRead: true,
    submodules: [
      {
        key: "productos",
        name: "Lista de Productos disponibles para configurar",
        description:
          "Lista de Productos disponibles en el almacen para configurar desde la app móvil",
      },
      {
        key: "ver_todos",
        name: "Ver todos los proyectos",
        description:
          "Permite ver todos los proyectos activos, no solo los asignados",
      },
      {
        key: "bitacoras",
        name: "Bitácoras de Configuración",
        description:
          "Crear y gestionar bitácoras de configuración de productos",
      },
    ],
  },
  {
    key: "pwa_transportista",
    name: "PWA - TRANSPORTISTA",
    icon: CarOutlined,
    disableRead: true,
    submodules: [
      {
        key: "mis_entregas",
        name: "Entregas en Obra",
        description:
          "Permite al transportista ver las salidas asignadas y confirmar la entrega en obra con la firma del encargado",
      },
    ],
  },
  {
    key: "vehiculos",
    name: "CONTROL VEHICULAR",
    icon: CarOutlined,
    submodules: [
      {
        key: "gestion",
        name: "Vehículos",
        description: "Alta, edición y baja de vehículos de la flotilla",
      },
      {
        key: "prestamos",
        name: "Préstamos",
        description: "Asignar, cancelar y revisar evidencia de préstamos de vehículos",
      },
    ],
  },
  {
    key: "activos",
    name: "CONTROL DE ACTIVOS",
    icon: MobileOutlined,
    submodules: [
      {
        key: "gestion",
        name: "Activos",
        description: "Alta, edición y baja de teléfonos celulares y radios de la empresa",
      },
      {
        key: "prestamos",
        name: "Préstamos de Activos",
        description: "Solicitudes y préstamos vigentes de activos",
      },
    ],
  },
];
